import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';

import { BaseUrl } from '../common/config';
import Loader from '../common/loader';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      loginStatus: "",
      loginMessage: "",
      isLoading: false
    };

    this.accountChange = this.accountChange.bind(this);
    this.emailChange = this.emailChange.bind(this);
    this.passwordChange = this.passwordChange.bind(this);

    this.getSettings();
  }

  componentDidMount() {
    if (localStorage.getItem("isLoggedIn"))
      window.location.href = '/home';

      var cookieChecked = localStorage.getItem('cookie_accepted');

      if(cookieChecked == '' || cookieChecked === null || cookieChecked == 'null'){
        document.body.classList.add('cookies-on');
      }
  }



   getSettings(){

    var loginDetails = {};
    if (localStorage.getItem('authData')) {
        loginDetails = JSON.parse(localStorage.getItem('authData'));
    }
      
    let URL = BaseUrl + "settings";
       axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
          let responseData = response.data.data[0];
          if(responseData !==''){
            if(responseData.maintananceMode === '1'){
               localStorage.setItem("sitemaintanance", '1');
               window.location.href = '/sitemaintanance';
            }else{
              localStorage.setItem("sitemaintanance", '0');

            }
         }
       }).catch((err) => {
          console.log(err);
       });
  }

  validateEmail($email) {
    var emailRegex = /[a-z0-9!#$%&'*+/=?^_{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;
    ///^[a-zA-Z0-9.]+@[a-zA-Z0-9.]+\.[a-zA-Z]{2,4}/^[^\s@]+@[^\s@-]+\.[^\s@]+$/;
    //console.log($email);
    if (!emailRegex.test($email)) {
      return false;
    } else {
      return true;
    }
  }

  accountChange(event) {
    var value = event.target.value;
    this.setState({
      account: value
    });
    this.setState({ loginStatus: "", loginMessage: "" });
  }

  emailChange(event) {
    var value = event.target.value;
    this.setState({
      email: value
    });
    this.setState({ loginStatus: "", loginMessage: "" });
  }

  passwordChange(event) {
    this.setState({
      password: event.target.value
    });
    this.setState({ loginStatus: "", loginMessage: "" });
  }

  loginOnSubmit = (event) => {
    event.preventDefault();
    let URL = BaseUrl + "login";

    //console.log(this.validateEmail(this.state.email), 'this.validateEmail(this.state.email)');
    if (this.validateEmail(this.state.email)) {
      let payload = {
        email: this.state.email.trim(),
        account: this.state.account.trim(),
        password: this.state.password
      }
      this.setState({ isLoading: true });
      axios.post(URL, payload).then((response) => {
        if (response.data.hasOwnProperty("data")) {

          this.setState({ loginMessage: "Incorrect Account Code or Email Address or Password" });
          this.setState({ loginStatus: response.data.data.status });

          if (response.data.data.status === 200) {
            var loginDetails = response.data.data;

            //console.log(loginDetails, 'loginDetails');
            
            localStorage.setItem("isLoggedIn", true);
            localStorage.setItem("priceband", response.data.data.accountPriceListId);
            localStorage.setItem("authData", JSON.stringify(response.data.data));
            localStorage.setItem('accountDeliverableDays', loginDetails.accountDeliverableDays);
            window.location = '/home';
          }else{
          this.setState({ loginStatus: 401 });
          this.setState({ loginMessage: response.data.data.message });
          }
        }
        this.setState({ isLoading: false });
      }).catch((error) => {
        console.log(error, 'error');
        this.setState({ isLoading: false });
      });
    }
    else {
      this.setState({ loginStatus: 401 });
      this.setState({ loginMessage: "Please enter valid Email Address" });
    }

  }

  render() {
    return (
      <>

        <Header />
        {!localStorage.getItem("isLoggedIn") && !this.state.isLoading && 
        <main className='main-section'>
        <div className="login">
          <div className="form">
            <form className="login-form" onSubmit={this.loginOnSubmit}>
              <h2>Client Login</h2>
              {(this.state.loginStatus) ? (this.state.loginStatus === 401 ? <p className='err-msg'>{this.state.loginMessage}</p> : "") : ""}
              <input type="text" id="accountCode" value={this.state.account} placeholder="Account Code" required onChange={this.accountChange} />
              <input type="text" id="accountEmail" value={this.state.email} placeholder="Email Address" required onChange={this.emailChange} />
              <input type="password" id="accountPassword" value={this.state.password} placeholder="Password" required onChange={this.passwordChange} />

              <button type='submit'>login</button>
            </form>

            <div className='forget-pass-field'>
            <Link className='pass-reset' to='/forgot-password'>Forgot or Reset Password</Link>
           </div>
            
          </div>
        </div>
        </main>
        }
        {this.state.isLoading && <main className='main-section'> <Loader propsClassName="load-lag" /> </main>}
        <Footer />
      </>
    )
  }
}

export default Login;